// import dayjs from "dayjs";

// export const generateDate = (
//   month = dayjs().month(),
//   year = dayjs().year()
// ) => {
//   const firstDateOfMonth = dayjs().year(year).month(month).startOf("month");
//   const lastDateOfMonth = dayjs().year(year).month(month).endOf("month");

//   const arrayOfDate = [];

//   for (let i = 0; i < firstDateOfMonth.day(); i++) {
//     const date = firstDateOfMonth.day(i);
//     arrayOfDate.push({
//       currentMonth: false,
//       date,
//     });
//   }

//   for (let i = firstDateOfMonth.date(); i <= lastDateOfMonth.date(); i++) {
//     arrayOfDate.push({
//       currentMonth: true,
//       date: firstDateOfMonth.date(i),
//       today:
//         firstDateOfMonth.date(i).toDate().toDateString() ===
//         dayjs().toDate().toDateString(),
//     });
//   }

//   const remaining = 42 - arrayOfDate.length;

//   for (
//     let i = lastDateOfMonth.date() + 1;
//     i <= lastDateOfMonth.date() + remaining;
//     i++
//   ) {
//     arrayOfDate.push({
//       currentMonth: false,
//       date: lastDateOfMonth.date(i),
//     });
//   }
//   return arrayOfDate;
// };

// export const months = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

import dayjs from "dayjs";

export const generateDate = (
  month = dayjs().month(),
  year = dayjs().year()
) => {
  const today = dayjs();
  const firstDateOfMonth = dayjs().year(year).month(month).startOf("month");
  const lastDateOfMonth = dayjs().year(year).month(month).endOf("month");

  const arrayOfDate = [];

  // Push previous month's days
  for (let i = 0; i < firstDateOfMonth.day(); i++) {
    const date = firstDateOfMonth.subtract(i + 1, "day");
    arrayOfDate.unshift({
      currentMonth: false,
      date,
      isPastDate: date.isBefore(today, "day"),
    });
  }

  // Push current month's days
  for (let i = firstDateOfMonth.date(); i <= lastDateOfMonth.date(); i++) {
    const date = firstDateOfMonth.date(i);
    arrayOfDate.push({
      currentMonth: true,
      date,
      today: date.toDate().toDateString() === today.toDate().toDateString(),
      isPastDate: date.isBefore(today, "day"),
    });
  }

  const remainingDays = 42 - arrayOfDate.length;
  for (let i = 1; i <= remainingDays; i++) {
    const date = lastDateOfMonth.add(i, "day");
    arrayOfDate.push({
      currentMonth: false,
      date,
      isPastDate: date.isBefore(today, "day"),
    });
  }

  return arrayOfDate;
};

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
